// extracted by mini-css-extract-plugin
export var callCard = "_qz-0";
export var callMessageButton = "_qz-1";
export var helpIcon = "_qz-3";
export var helpIconContainer = "_qz-4";
export var verticalDivider = "_qz-2";